import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { Button, Col, Form, Row, Table } from "react-bootstrap";
import { root_url } from "../setting";
import { getBearerString } from "../utils/Auth";
import KakaoMapForControl from "./KakaoMapForControl";

const AdminMapResult = () => {
  const [userInfo, setUserInfo] = useState({});
  const [pathFromServer, setPathFromServer] = useState([]);
  const [seq, setSeq] = useState([]);
  const [logTime, setLogTime] = useState([]);
  const [selectedSeq, setSelectedSeq] = useState("");
  const [deleteSeq, setDeleteSeq] = useState([]);
  const [flag, setFlag] = useState(10);

  const inputRef = useRef(null);

  useEffect(() => {
    let location = decodeURI(window.location.href.split("?")[1], "UTF-8");
    let runnerSeq = location.split("&")[0].split("=")[1];
    let runnerName = location.split("&")[1].split("=")[1];
    let cellphone = location.split("&")[2].split("=")[1];
    let ticketName = location.split("&")[3].split("=")[1];

    setUserInfo({ runnerSeq, runnerName, cellphone, ticketName });

    const getData = async () => {
      try {
        let response = await axios.post(`${root_url}/api/v1/footprint`, {
          runnerSeq: runnerSeq,
          runnerName: runnerName,
          cellphone: cellphone,
        });
        let path = response.data.traces;
        let tmpPath = [];
        let tmpSeq = [];
        let tmpLogTime = [];
        path.map((item, key) => {
          tmpPath.push({ La: item.longitude, Ma: item.latitude });
          tmpSeq.push(item.seq);
          tmpLogTime.push(item.logtime);
        });
        setSeq(tmpSeq);
        setLogTime(tmpLogTime);
        setPathFromServer(tmpPath);
        console.log(tmpSeq);
      } catch (error) {
        if (error?.response?.status === 403) {
          alert("권한이 존재하지 않습니다.");
          localStorage.setItem("accessToken", "");
          window.location.href = "/admin/login";
        }
        if (error.response === undefined) {
          alert(
            "시스템 서비스가 원할하지 않습니다. 관리자에게 문의하세요. (code - A0001)"
          );
          console.log("error", error);
          return;
        } else {
          alert(error.response.data.errorMessage);
          return;
        }
      }
    };

    getData();
  }, []);
  return (
    <div>
      {pathFromServer.length === 0 ? (
        ""
      ) : (
        <>
          <Row>
            <Col className="col-4">
              <h4 className="mt-4 mb-4">
                {userInfo.runnerName}님의 [{userInfo.ticketName}] 기록{" "}
              </h4>
            </Col>
            <Col className="col-6">
              <Form.Control
                as="select"
                className="my-1 mr-sm-2"
                id="inlineFormCustomSelectPref"
                custom
                onChange={(e) => {
                  let flag = e.target.value;
                  setFlag(flag);
                }}
              >
                <option value="10">10줄</option>
                <option value="30">30줄</option>
                <option value="50">50줄</option>
                <option value="100">100줄</option>
              </Form.Control>
            </Col>
            <Col className="col-2">
              <Button
                className="mt-4 mb-4"
                onClick={async () => {
                  let seqString = deleteSeq.toString();
                  console.log(seqString);
                  let accessToken = getBearerString();
                  let headers = {
                    headers: {
                      Authorization: accessToken,
                    },
                  };
                  try {
                    let response = await axios.post(
                      `${root_url}/api/admin/readjust`,
                      {
                        runnerSeq: userInfo.runnerSeq,
                        recordIndexes: seqString,
                        validation: false,
                      },
                      headers
                    );
                    alert("저장하였습니다.");
                  } catch (error) {
                    if (error?.response?.status === 403) {
                      alert("권한이 존재하지 않습니다.");
                      localStorage.setItem("accessToken", "");
                      window.location.href = "/admin/login";
                    }
                    if (error.response === undefined) {
                      alert(
                        "시스템 서비스가 원할하지 않습니다. 관리자에게 문의하세요. (code - A0001)"
                      );
                      console.log("error", error);
                      return;
                    } else {
                      alert(error.response.data.errorMessage);
                      return;
                    }
                  }
                }}
              >
                저장
              </Button>
            </Col>
          </Row>
          <Row>
            <Col>
              <div
                style={{ width: "100%", height: "40vh", position: "relative" }}
              >
                <KakaoMapForControl path={pathFromServer} flag={flag} />
              </div>
            </Col>
            <Col>
              <div
                style={{
                  height: "40vh",
                  overflowY: "scroll",
                  marginBottom: "100px",
                }}
              >
                <Table className="text-center">
                  <thead>
                    <th className="col-2">no.</th>
                    <th className="col-3">일련번호</th>
                    <th>위치</th>
                    {/*<th>위도</th><th>경도</th>*/}
                  </thead>
                  <tbody>
                    {pathFromServer.map((item, key) => {
                      return (
                        <tr>
                          <td>{key + 1}</td>
                          <td
                            onClick={() => {
                              setSelectedSeq(seq[key]);
                            }}
                          >
                            {seq[key]}
                          </td>
                          <td>{logTime[key].split("년")[1]}</td>
                          {/*<td>{item.Ma}</td><td>{item.La}</td>*/}
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            </Col>
          </Row>
        </>
      )}
      <div>
        <p>
          선택 일련번호 :
          <input type="text" ref={inputRef} value={selectedSeq} disabled />
        </p>
        <div style={{ display: "flex" }}>
          <Button
            style={{ marginRight: "30px" }}
            onClick={() => {
              let tmpPath = [];
              let tmpSeq = [];
              let deleteTmpSeq = [...deleteSeq];
              let tmp = seq.indexOf(selectedSeq);
              console.log("pressed!");
              pathFromServer.map((item, key) => {
                if (key >= tmp) {
                  tmpPath.push(item);
                  tmpSeq.push(seq[key]);
                } else {
                  deleteTmpSeq.push(seq[key]);
                }
              });
              setPathFromServer(tmpPath);
              setSeq(tmpSeq);
              setDeleteSeq(deleteTmpSeq);
            }}
          >
            이전 삭제
          </Button>
          <Button
            style={{ marginRight: "30px" }}
            onClick={() => {
              let tmpPath = [];
              let tmpSeq = [];
              let deleteTmpSeq = [...deleteSeq];
              let tmp = seq.indexOf(selectedSeq);
              console.log("pressed!");
              pathFromServer.map((item, key) => {
                if (key <= tmp) {
                  tmpPath.push(item);
                  tmpSeq.push(seq[key]);
                } else {
                  deleteTmpSeq.push(seq[key]);
                }
              });
              setPathFromServer(tmpPath);
              setSeq(tmpSeq);
              setDeleteSeq(deleteTmpSeq);
            }}
          >
            이후 삭제
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AdminMapResult;
